package demos.buttons

import androidx.compose.animation.*
import androidx.compose.animation.core.*
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Icon
import androidx.compose.material.LocalContentColor
import androidx.compose.material.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Phone
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.delay
import org.jetbrains.skiko.currentNanoTime
import kotlin.time.Duration.Companion.nanoseconds

const val CALL_BUTTON = "79264381339eb4744ae35c5b5a465022f7b759f45e66c86af652aa4f1efd0ec7"


sealed class CallState {
    object Ringing : CallState()
    object InCall : CallState()
}

private val green: Color = Color(0xff67ed4c)
private val red: Color = Color(0xffed4c67)

@OptIn(kotlin.time.ExperimentalTime::class)
@Composable
fun CallButton() {

    var callState: CallState by remember { mutableStateOf(CallState.Ringing) }
    val transition = updateTransition(callState, label = "call state")

    var touched by remember { mutableStateOf(false) }

    val scale by animateFloatAsState(
        targetValue = if (touched) .94f else 1f, animationSpec = spring(
            dampingRatio = Spring.DampingRatioMediumBouncy,
            stiffness = Spring.StiffnessMedium
        )
    )

    val color by transition.animateColor {
        when (callState) {
            CallState.Ringing -> green
            CallState.InCall -> red
        }
    }

    val phoneRotation by transition.animateFloat(
        transitionSpec = {
            spring(
                dampingRatio = Spring.DampingRatioMediumBouncy,
                stiffness = Spring.StiffnessLow,
            )
        }
    ) {
        when (callState) {
            CallState.Ringing -> 135f
            CallState.InCall -> 0f
        }
    }

    Column(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        AnimatedVisibility(
            visible = callState == CallState.InCall,
            enter = fadeIn() + expandVertically(
                expandFrom = Alignment.Top, clip = false
            ),
            exit = fadeOut() + shrinkVertically(
                shrinkTowards = Alignment.Top, clip = false
            ),
        ) {
            var timeElapsed by remember { mutableStateOf("00:00") }
            LaunchedEffect(Unit) {
                val start = currentNanoTime()
                while (true) {
                    delay(1000)
                    val secondsElapsed = (currentNanoTime() - start).nanoseconds.inWholeSeconds.toInt()
                    val minutes = "${secondsElapsed / 60}".padStart(2, '0')
                    val seconds = "${secondsElapsed % 60}".padStart(2, '0')
                    timeElapsed = "$minutes:$seconds"
                }
            }
            Text(
                timeElapsed,
                modifier = Modifier.padding(bottom = 12.dp)
            )
        }
        Box(
            Modifier
                .scale(scale)
                .pointerInput(Unit) {
                    detectTapGestures(
                        onPress = {
                            touched = true
                            awaitRelease()
                            callState = when (callState) {
                                CallState.Ringing -> CallState.InCall
                                CallState.InCall -> CallState.Ringing
                            }
                            touched = false
                        }
                    )
                }
                .background(
                    color,
                    shape = RoundedCornerShape(100.dp)
                )
                .padding(horizontal = 8.dp, vertical = 8.dp)
        ) {
            CompositionLocalProvider(
                LocalContentColor provides Color.Black,
            ) {
                Row(
                    horizontalArrangement = Arrangement.Center,
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Icon(
                        imageVector = Icons.Default.Phone,
                        contentDescription = "phone icon",
                        modifier = Modifier
                            .rotate(phoneRotation)
                            .padding(8.dp)
                    )

                    AnimatedVisibility(visible = callState == CallState.InCall) {
                        Text("END")
                    }
                }
            }
        }
    }
}